angular.module('FlexyBeautyApp.services')
    .factory('BasicAuthRole', ['gettextCatalog', 'StoreAppCode', 'BookingCreator', 'BasicAuthRoleSaleCreationBehavior',
        'SaleStatus', 'CompanyType', "Brand", "Countries", "CompanyTypes",
        function (gettextCatalog, StoreAppCode, BookingCreator, BasicAuthRoleSaleCreationBehavior,
                  SaleStatus, CompanyType, Brand, Countries, CompanyTypes) {
        return {
            GOOGLE_ROLE: {
                role: 'GoogleRole',
                storeAppCode: StoreAppCode.OPTION_RESERVE_WITH_GOOGLE_STORE_APP_CODE,
                bookingCreator: BookingCreator.RWG.key,
                label : gettextCatalog.getString('Réserver avec Google'),
                webSite : "#",
                proSite : '#',
                basicAuthRoleSaleCreationBehavior : BasicAuthRoleSaleCreationBehavior.getReserveWithGoogleSaleCreationBehavior(),
                displaySaleAlert: function () {
                    return false;
                },
                canPartnerUpdatePayment: function () {
                    return true;
                },
                phoneNumber: '',
                isCompanyTypeCompliant: function (companyView) {
                    return companyView.companyTypeId === CompanyType.HAIRDRESSING_SALON.id
                            || companyView.companyTypeId === CompanyType.LOREAL_HAIR_SALON.id
                            || companyView.companyTypeId === CompanyType.BEAUTY_INSTITUTE.id
                            || companyView.companyTypeId === CompanyType.SPA.id;
                }
            },
            LE_CISEAU_ROLE: {
                role: 'leCiseauRole',
                storeAppCode: StoreAppCode.OPTION_LE_CISEAU_STORE_APP_CODE,
                bookingCreator: BookingCreator.LE_CISEAU.key,
                label : Brand.marketplace.label,
                webSite : Brand.marketplace.url.website,
                proSite : Brand.marketplace.url.proSite,


                basicAuthRoleSaleCreationBehavior : BasicAuthRoleSaleCreationBehavior.getLeCiseauSaleCreationBehavior(),
                displaySaleAlert: function (saleStatus) {
                    return (saleStatus === SaleStatus.CREATED || saleStatus === SaleStatus.ADVANCE || saleStatus === SaleStatus.WAITING);
                },
                canPartnerUpdatePayment: function (saleStatus, saleSetting) {
                    return (saleStatus !== SaleStatus.SOLD) || (saleStatus === SaleStatus.SOLD && saleSetting);
                },
                isCompanyTypeCompliant: function (companyView) {
                    return companyView.companyTypeId !== CompanyType.OTHER.id
                },
                isCountryCompliant: function(companyView) {
                    let compliantCountries = [Countries.FRANCE.countryCode, Countries.GUADELOUPE.countryCode, Countries.MARTINIQUE.countryCode, Countries.REUNIONISLAND.countryCode];
                    return compliantCountries.includes(companyView.country);
                },
                isAccountTypeCompliant: function(companyView) {
                    let compliantAccountTypes = [CompanyTypes.PARTNER, CompanyTypes.CUSTOMER, CompanyTypes.BILLINGISSUE, CompanyTypes.NEW_ACCOUNT];
                    return compliantAccountTypes.find(accountType => accountType.value === companyView.type) != null;
                }
            }
        };
}])

    .factory('BasicAuthRoleFactory', ['BasicAuthRole', function (BasicAuthRole) {
        return {
            getBasicAuthByBookingCreator: function (creator) {
                for (let basicAuthRole in BasicAuthRole) {
                    if (BasicAuthRole.hasOwnProperty(basicAuthRole) && BasicAuthRole[basicAuthRole].bookingCreator === creator) {
                        return BasicAuthRole[basicAuthRole];
                    }
                }
            }
        };
}]);



// WEBPACK FOOTER //
// ./js/services/views/ConstantsBasicAuthRole.js